var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
import { useSafeId } from '../../../core/hooks/useSafeId';
/**
 * @tdr
 */
export var British = svgIcon(function (props) {
    var id = useSafeId();
    var mask = "url(#".concat(id, ")");
    return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("mask", { id: id, maskUnits: "userSpaceOnUse", x: "1", y: "1", width: "18", height: "18" },
            React.createElement("path", { d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02943 1 1 5.02944 1 10C1 14.9706 5.02943 19 10 19Z", fill: "#D9D9D9" })),
        React.createElement("g", { mask: mask },
            React.createElement("path", { d: "M28.043 0.977539H-8.04297V19.0205H28.043V0.977539Z", fill: "white" }),
            React.createElement("path", { d: "M28.0444 8.19473H11.805V0.977539H8.1964V8.19473H-8.04297V11.8033H8.1964V19.0205H11.805V11.8033H28.0444", fill: "#CF1822" }),
            React.createElement("path", { d: "M16.0152 13.0066H18.7047L28.0444 17.6758V19.0205M3.98614 6.9914H1.29668L-8.04297 2.32227V0.977539L3.98614 6.9914ZM3.98614 13.0066H6.6756L-5.35351 19.0205H-8.04297L3.98614 13.0066ZM16.0152 6.9914H13.3258L25.3549 0.977539H28.0444L16.0152 6.9914Z", fill: "#CF1822" }),
            React.createElement("path", { d: "M-8.04297 13.0066V17.0034L-0.0494437 13.0066M28.0444 13.0066V17.0034L20.0494 13.0066H28.0444ZM-8.04297 6.9914V2.99464L-0.0494437 6.9914H-8.04297ZM28.0444 6.9914V2.99464L20.0494 6.9914H28.0444ZM6.99307 19.0205V13.5196L-4.00878 19.0205H6.99307ZM13.0083 19.0205V13.5196L24.0102 19.0205H13.0083ZM6.99307 0.977539V6.47846L-4.00878 0.977539H6.99307ZM13.0083 0.977539V6.47846L24.0102 0.977539H13.0083Z", fill: "#193656" })),
        React.createElement("path", { d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02943 1 1 5.02944 1 10C1 14.9706 5.02943 19 10 19Z", stroke: "black", strokeWidth: "0.5", strokeMiterlimit: "10" })));
});
//# sourceMappingURL=British.js.map